import { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { FaInfoCircle, FaExclamationTriangle } from "react-icons/fa";
import '../styles/data.css';
import Account from '../components/Account';
import mtn from "../assets/mtn1.jpg";
import glo from "../assets/glo.jpg";
import airtel from "../assets/airtel.jpg";
import etisalat from "../assets/9mobile.jpg";
import Toast from "../components/Toast"; // wherever you save it


const dataPlans = {
    MTN: [
        { size: "75MB", price: 80, validity: "Daily", code: "88" },
        { size: "110MB", price: 105, validity: "Daily", code: "89" },
        { size: "230MB", price: 200, validity: "Daily", code: "90" },
        { size: "750MB(3 Days)", price: 450, validity: "Daily", code: "92" },
        { size: "1.0GB", price: 270, validity: "Daily", code: "411" },
        { size: "2.5GB", price: 570, validity: "Daily", code: "412" },
        { size: "1.0GB", price: 490, validity: "Daily", code: "85" },
        { size: "1.5GB (2 Days)", price: 590, validity: "Daily", code: "93" },
        { size: "2.0GB (2 Days)", price: 735, validity: "Daily", code: "96" },
        { size: "2.5GB", price: 875, validity: "Daily", code: "94" },
        { size: "3.2GB(2 Days)", price: 970, validity: "Daily", code: "87" },
        { size: "7.0GB(2 Days)", price: 1760, validity: "Daily", code: "413" },
        //{ size: "1.2GB", price: 735, validity: "Weekly", code: "99" },
        { size: "1.5GB", price: 972, validity: "Weekly", code: "95" },
        { size: "3.5GB", price: 1470, validity: "Weekly", code: "123" },
        { size: "6.0GB", price: 2430, validity: "Weekly", code: "122" },
        { size: "11GB", price: 3400, validity: "Weekly", code: "129" },
        //{ size: "20GB", price: 4950, validity: "Weekly", code: "118" },
        { size: "500MB", price: 420, validity: "Monthly", code: "137" },
        { size: "2.0GB", price: 1360, validity: "Monthly", code: "6" },
        { size: "2.7GB", price: 1950, validity: "Monthly", code: "97" },
        { size: "3.0GB", price: 2000, validity: "Monthly", code: "7" },
        { size: "5.0GB", price: 2800, validity: "Monthly", code: "8" },
        { size: "5.0GB + ₦868 Free Airtime", price: 2930, validity: "Monthly", code: "136" },
        { size: "7.0GB", price: 3400, validity: "Monthly", code: "119" },
        { size: "1.12GB + ₦335 Free Airtime", price: 1470, validity: "Monthly", code: "44" },
        { size: "12.5GB", price: 5320, validity: "Monthly", code: "100" },
        { size: "16.5GB", price: 6300, validity: "Monthly", code: "102" },
        { size: "20.0GB", price: 7300, validity: "Monthly", code: "101" },
        { size: "25.0GB", price: 8700, validity: "Monthly", code: "98" },
        { size: "75.0GB", price: 17450, validity: "Monthly", code: "130" },
        { size: "150.0GB(60 Days)", price: 38750, validity: "Monthly", code: "133" },
        { size: "165.0GB", price: 33900, validity: "Monthly", code: "131" },
        { size: "250.0GB", price: 53200, validity: "Monthly", code: "132" },
        { size: "480.0GB(90 Days)", price: 87000, validity: "Monthly", code: "134" },
    ],
    AIRTEL: [
        { size: "150MB (2 Days)", price: 75, validity: "Daily", code: "103" },
        { size: "300MB (2 Days)", price: 135, validity: "Daily", code: "104" },
        { size: "600MB", price: 270, validity: "Daily", code: "108" },
        { size: "1.0GB", price: 360, validity: "Daily", code: "109" },
        { size: "1.5GB", price: 410, validity: "Daily", code: "110" },
        { size: "2.0GB(2 Days)", price: 530, validity: "Daily", code: "107" },
        { size: "4.0GB(2 Days)", price: 800, validity: "Daily", code: "111" },
        { size: "500MB", price: 510, validity: "Weekly", code: "65" },
        { size: "1.0GB", price: 790, validity: "Weekly", code: "75" },
        { size: "1.5GB", price: 990, validity: "Weekly", code: "66" },
        { size: "3.5GB", price: 1480, validity: "Weekly", code: "67" },
        { size: "3.5GB(+ Free 3.5GB Bonus)", price: 1540, validity: "Weekly", code: "106" },
        { size: "6.0GB", price: 2450, validity: "Weekly", code: "74" },
        { size: "7.0GB", price: 2150, validity: "Weekly", code: "112" },
        { size: "10.0GB", price: 2950, validity: "Weekly", code: "120" },
        { size: "18.0GB", price: 4900, validity: "Weekly", code: "121" },
        { size: "2.0GB", price: 1480, validity: "Monthly", code: "124" },
        { size: "3.0GB", price: 1960, validity: "Monthly", code: "68" },
        { size: "4.0GB", price: 2460, validity: "Monthly", code: "69" },
        { size: "8.0GB", price: 2950, validity: "Monthly", code: "70" },
        { size: "10.GB", price: 3900, validity: "Monthly", code: "71" },
        { size: "13.GB", price: 4900, validity: "Monthly", code: "125" },
        { size: "18.GB", price: 5820, validity: "Monthly", code: "72" },
        { size: "35.GB", price: 9850, validity: "Monthly", code: "127" },
        { size: "60.GB", price: 14740, validity: "Monthly", code: "128" },
    ],
    GLO: [
        { size: "200MB", price: 110, validity: "Weekly", code: "55" },
        { size: "500MB", price: 210, validity: "Monthly", code: "56" },
        { size: "1.0GB", price: 410, validity: "Monthly", code: "57" },
        { size: "2.0GB", price: 820, validity: "Monthly", code: "58" },
        { size: "3.0GB", price: 1215, validity: "Monthly", code: "59" },
        { size: "5.0GB", price: 2025, validity: "Monthly", code: "60" },
        { size: "10GB", price: 4050, validity: "Monthly", code: "61" },

    ],

    "9MOBILE": [
        { /* plans */ }
    ],
};

const dummyTabs = ["Daily", "Weekly", "Monthly"];

const BuySmartData = () => {
    const { buySmartData, currentUser, fetchNotifications } = useContext(AuthContext);
    const [network, setNetwork] = useState("MTN");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [activeTab, setActiveTab] = useState("Daily");
    // Errors
    const [errorPhone, setErrorPhone] = useState(null);
    const [errorNetwork, setErrorNetwork] = useState(null);
    const [errorPlan, setErrorPlan] = useState(null);

    // Refs for scrolling
    const phoneRef = useRef(null);
    const networkRef = useRef(null);
    const planRef = useRef(null);

    const navigate = useNavigate();

    const handleBuy = (planCode, price) => {

        let isValid = true;

        if (!network) {
            setErrorNetwork("Please select a network provider.");
            networkRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            isValid = false;
        } else {
            setErrorNetwork(null);
        }

        if (!phoneNumber) {
            setErrorPhone("Please enter a phone number.");
            phoneRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            isValid = false;
        } else if (!/^\d{11}$/.test(phoneNumber)) {
            setErrorPhone("Phone number must be exactly 11 digits.");
            phoneRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            isValid = false;
        } else {
            setErrorPhone(null);
        }

        if (!planCode || !price) {
            setErrorPlan("⚠️ Please select a valid plan.");
            planRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            isValid = false;
        } else {
            setErrorPlan(null);
        }

        if (!isValid) return;

        navigate("/review", {
            state: {
                type: "data",
                details: {
                    network: network.toUpperCase(),
                    phoneNumber,
                    planSize: dataPlans[network].find(plan => plan.code === planCode)?.size || "",
                    planCode,
                    amount: price
                }
            }
        });


    };


    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <div className="shadow-md airtime">

            <Account />

            {message && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}


            {message && (
                <Toast message={message.text} type={message.type} />
            )}

            <div className="form-section">
                <div className="network-selection" ref={networkRef}>
                    <label className="network-label">Select Network Provider</label>

                    {screenWidth >= 800 ? (
                        <>
                            <select
                                value={network}
                                onChange={(e) => {
                                    setNetwork(e.target.value);
                                    setErrorNetwork(null);
                                }}
                                className="airtime-input styled-select w-full border rounded-md"
                            >
                                <option value="">-- Select Network --</option>
                                <option value="MTN">MTN</option>
                                <option value="GLO">Glo</option>
                                <option value="AIRTEL">Airtel</option>
                                <option value="9MOBILE">9mobile</option>
                            </select>
                            {errorNetwork && <p className="error-input">{errorNetwork}</p>}
                        </>
                    ) : (
                        <>
                            <div className="network-options">
                                {[
                                    { id: "MTN", src: mtn, alt: "MTN" },
                                    { id: "GLO", src: glo, alt: "Glo" },
                                    { id: "AIRTEL", src: airtel, alt: "Airtel" },
                                    { id: "9MOBILE", src: etisalat, alt: "9mobile" }
                                ].map(({ id, src, alt }) => (
                                    <img
                                        key={id}
                                        src={src}
                                        alt={alt}
                                        onClick={() => {
                                            setNetwork(id);
                                            setErrorNetwork(null);
                                        }}
                                        className={`
                network-image 
                ${id === "MTN" ? "mtn-image" : ""} 
                ${id === "GLO" ? "glo-image" : ""} 
                ${network === id ? "selected" : ""}
              `}
                                    />
                                ))}
                            </div>
                            {errorNetwork && <p className="error-input">{errorNetwork}</p>}
                        </>
                    )}
                </div>

                <div ref={phoneRef}>
                    <label className="network-label label-right">No Beneficiary Available</label>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={11}
                        value={phoneNumber}
                        onChange={(e) => {
                            const raw = e.target.value;

                            // Only allow digits and max 11 characters
                            if (/^\d{0,11}$/.test(raw)) {
                                setPhoneNumber(raw);
                            }
                        }}
                        className="airtime-input w-full  border rounded-md"
                        placeholder="Mobile Number"
                        required
                    />
                    {errorPhone && <p className="error-input">{errorPhone}</p>}
                </div>
            </div>

            <div className="tab-header">
                {dummyTabs.map(tab => (
                    <button
                        key={tab}
                        className={`tab-button ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            <div className="plans-grid" ref={planRef}>
                {Array.isArray(dataPlans[network]) ? (
                    dataPlans[network].filter(plan => plan.validity === activeTab).length > 0 ? (
                        dataPlans[network]
                            .filter(plan => plan.validity === activeTab)
                            .map((plan, i) => (
                                <div key={i} className="plan-card">
                                    <h4>{plan.size} Data Plan</h4>
                                    <p>Get some data and bonus minutes for just ₦{plan.price}</p>
                                    <div className="plan-details">
                                        <div className="plan-row">
                                            <div className="plan-column p-cl-1">
                                                <span>Validity</span>
                                                <strong>{plan.validity}</strong>
                                            </div>
                                            <div className="plan-column">
                                                <span>Price</span>
                                                <strong>₦{plan.price}</strong>
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                                className="buy-btn"
                                                onClick={() => handleBuy(plan.code, plan.price)}
                                                disabled={loading}
                                            >
                                                {loading ? "Processing..." : "Buy Now"}
                                            </button>
                                        </div>
                                    </div>
                                    {errorPlan && <p className="error-input">{errorPlan}</p>}
                                </div>
                            ))
                    ) : (
                        <div className="no-plans-message">
                            <FaInfoCircle className="no-transactions-icon" size={40} color="#aaa" />
                            <p>
                                There are currently no available <strong>{activeTab}</strong> plans for <strong>{network}</strong>.
                                <br />
                                Please check back later or choose another plan type.
                            </p>
                        </div>
                    )
                ) : (
                    <div style={{ textAlign: "center", marginTop: "3rem" }}>
                        <FaExclamationTriangle color="#aaa" size={40} style={{ marginBottom: "10px" }} />
                        <p>Invalid network selected.</p>
                    </div>
                )}
            </div>

        </div>
    );
};

export default BuySmartData;
